/* eslint-disable @typescript-eslint/ban-types */
import { useEffect, useState } from 'react'

interface JustSubmittedProps {
  isDirty: boolean
  isSubmitSuccessful: boolean | undefined
}

export const useJustSubmitted = ({ isDirty, isSubmitSuccessful }: JustSubmittedProps): boolean => {
  const [dirty, setDirty] = useState(false)
  const [submitSuccessful, setSubmitSuccessful] = useState(false)
  const isFieldSubmitting = dirty && submitSuccessful

  useEffect(() => {
    if (isDirty) {
      setDirty(true)
    }
  }, [isDirty])

  useEffect(() => {
    if (isSubmitSuccessful) {
      setSubmitSuccessful(true)
    }
  }, [isSubmitSuccessful])

  useEffect(() => {
    if (!isSubmitSuccessful) {
      return
    }
    const timeout = setTimeout(() => {
      setDirty(false)
      setSubmitSuccessful(false)
    }, 3000)
    return () => clearTimeout(timeout)
  }, [isSubmitSuccessful])

  return isFieldSubmitting
}
